import React, { Component } from 'react';
import PropTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';

import config from 'config';
import PresetSelect from './preset-select';
import CustomSelect from './custom-select';

const TipPose = posed.div({
    enter: { opacity: 1 },
    exit: { opacity: 0 },
});

export default class ContributionTip extends Component {
    static propTypes = {
        onSelect: PropTypes.func.isRequired,
        contribution: PropTypes.number.isRequired,
        showFlash: PropTypes.func.isRequired,
        recipientName: PropTypes.string.isRequired,
        tip: PropTypes.number,
    };

    static defaultProps = {
        tip: null,
    };

    state = {
        isCustom: false,
    };

    componentDidMount() {
        const { tip } = this.props;
        if (!tip) this.handleShowPresets();
    }

    get presets() {
        const { contribution } = this.props;
        const isLarge = contribution > 50000;
        const percents = isLarge ? [14, 12, 10] : [20, 15, 10];
        const minimum = config('/minimum_tip_charge');

        const presets = percents
            .map(percent => ({
                label: `${percent}%`,

                // Round the amount to the nearest 5 cents
                value: Math.round(Math.round((contribution * (percent / 100)) / 5) * 5),

                // We only want preset values that are above the minimum (chargeable) tip
            }))
            .filter(({ value }) => value > minimum);

        // If we've omitted any values, we'll want to also include the minimum (chargeable) tip as an option
        if (presets.length < 3) {
            presets.push({ label: 'Min', value: minimum });
        }

        return presets;
    }

    handleShowCustom = () => this.setState({ isCustom: true });

    handleShowPresets = () => {
        const { onSelect } = this.props;
        this.setState({ isCustom: false });
        onSelect(this.presets[this.presets.length > 1 ? 1 : 0].value);
    };

    render() {
        const { tip, onSelect, showFlash, recipientName } = this.props;
        const { isCustom } = this.state;

        // Need to wait for initial tip value to be set
        if (tip === null) return null;

        return (
            <div className="border-b-3 border-gray-20 pb-8 mb-8" data-testid="tip-jar">
                <div className="md:flex justify-between items-center mb-4 font-medium text-16 text-gray-70">
                    <p className="sm:mb-2">Tip Pledge It</p>

                    <PoseGroup withParent={false}>
                        {isCustom ? (
                            <TipPose key="custom">
                                <CustomSelect
                                    value={tip}
                                    onChange={onSelect}
                                    onPresets={this.handleShowPresets}
                                    showFlash={showFlash}
                                />
                            </TipPose>
                        ) : (
                            <TipPose key="preset">
                                <PresetSelect
                                    options={this.presets}
                                    selected={this.presets.find(x => x.value === tip)}
                                    onSelect={({ value }) => onSelect(value)}
                                    onCustom={this.handleShowCustom}
                                />
                            </TipPose>
                        )}
                    </PoseGroup>
                </div>

                <p className="text-12 text-gray-30 font-medium leading-normal">
                    Pledge It is proud to be free for {recipientName} and all campaign organizers.
                    We rely on the generosity of donors like you to continue offering our platform
                    for free.
                </p>
            </div>
        );
    }
}
